export default function phone(value) {
  const regexp = RegExp(/^8\s[(][0-9]{3}[)]\s[0-9]{3}[-][0-9]{2}[-][0-9]{2}$/);
  return regexp.test(value);
}
